import { useEffect, useRef, useState } from 'react';
import style from './styles/index.module.less';
import React from 'react';
import {
  generateUUID,
  getKouziAccessToken,
  getKouziRefreshToken,
  setKouziAccessToken,
  setKouziRefreshToken,
} from '@/utils';

const KouziChatView: React.FC = ({}) => {
  const clientId = '70164970043346901208603069548281.app.coze'; // 客户端 ID
  const clientSecret = 'ClHI4nYSV24znSz37kkrqEbh5H7RtTYx06qApNHFbE5cgMrJ'; // Client Secret
  const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
  const [chatBotWidth, setChatBotWidth] = useState<number>(window.innerWidth); // 保存宽度的状态
  const [currentUser, setCurrentUser] = useState<any>(
    localStorage.getItem('userInfo')
  );
  const accessToken = getKouziAccessToken();
  const refreshToken = getKouziRefreshToken();

  useEffect(() => {
    console.log(localStorage.getItem('eduChartBotId'));
    console.log(REDIRECT_URL);
    const handleResize = () => {
      setChatBotWidth(window.innerWidth); // 更新宽度
    };
    if (accessToken && refreshToken) {
      refreshAccessToken(); // 刷新token
      startTokenRefreshCountdown();
      window.addEventListener('resize', handleResize); // 监听窗口大小变化
    } else {
      const params = new URLSearchParams(window.location.search);
      const state = params.get('state');
      const code = params.get('code');
      if (code) {
        getAccessToken(code);
      } else {
        const url = `https://www.coze.cn/api/permission/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${REDIRECT_URL}&state=${generateUUID()}`;
        window.location.href = url;
      }
    }

    return () => {
      window.removeEventListener('resize', handleResize); // 清理事件监听器
    };
  }, []);

  useEffect(() => {
    const CozeWebSDK: any = (window as any).CozeWebSDK;
    const cozeWebSDK = new CozeWebSDK.WebChatClient({
      config: {
        bot_id: localStorage.getItem('eduChartBotId'),
      },
      auth: {
        type: 'oauth',
        token: getKouziAccessToken(),
        onRefreshToken: async () => getKouziRefreshToken(),
      },
      userInfo: {
        id: currentUser?.id,
        url: currentUser?.avatar,
        nickname: currentUser?.name,
      },
      ui: {
        base: {
          icon: 'https://32005431.s21i.faiusr.com/4/ABUIABAEGAAgiP-BugYo1rTy-gEw8AE48AE.png',
        },
        //隐藏右下角自带图标
        asstBtn: {
          isNeed: false,
        },
        chatBot: {
          title: localStorage.getItem('eduChartTitle'),
          width: chatBotWidth * 0.95,
          el: document.getElementById('talkchatview'),
          onBeforeHide: () => {
            return false;
          },
        },
        footer: {
          isShow: false,
        },
      },
    });
    cozeWebSDK.showChatBot();
    return () => {
      cozeWebSDK?.destroy();
    };
  }, [chatBotWidth]); // 当宽度变化时重新初始化聊天窗口

  // 发送POST请求交换授权码为access_token
  async function getAccessToken(code: any) {
    try {
      const response = await fetch(
        'https://api.coze.cn/api/permission/oauth2/token',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${clientSecret}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            grant_type: 'authorization_code',
            code: code,
            client_id: clientId,
            redirect_uri: REDIRECT_URL,
          }),
        }
      );
      const data = await response.json();

      // 存储 access_token 和 refresh_token 到 localStorage
      if (data.access_token) {
        setKouziAccessToken(data.access_token);
      }
      if (data.refresh_token) {
        setKouziRefreshToken(data.refresh_token);
      }
      if (data.access_token && data.refresh_token) {
        // 重定向到不带查询参数的 redirectUri
        window.history.replaceState({}, '', REDIRECT_URL);
      }
      return data;
    } catch (error) {
      console.error('Error:', error); // 捕获错误并打印
    }
  }

  // 刷新 access_token 的方法
  async function refreshAccessToken() {
    try {
      const response = await fetch(
        'https://api.coze.cn/api/permission/oauth2/token',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${clientSecret}`,
          },
          body: JSON.stringify({
            grant_type: 'refresh_token',
            refresh_token: getKouziRefreshToken(),
            client_id: clientId,
          }),
        }
      );
      const data = await response.json();

      // 存储刷新后的 access_token 和 refresh_token 到 localStorage
      if (data.access_token) {
        setKouziAccessToken(data.access_token);
      }
      if (data.refresh_token) {
        setKouziRefreshToken(data.refresh_token);
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
  }

  // 10分钟刷新一次token
  function startTokenRefreshCountdown() {
    let countdown = 600;
    setInterval(() => {
      countdown--;
      if (countdown < 0) {
        refreshAccessToken();
        countdown = 600;
      }
    }, 1000);
  }

  return (
    <div className={style.parent}>
      <div id="talkchatview" className={style.chat}></div>
    </div>
  );
};

export default KouziChatView;
